//
//  BenefitsDocuments Reducer
//  CXA Apollo
//
//  Created on 16/12/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//

import {
  BENEFITS_DOCUMENTS_LOAD_BEGIN,
  BENEFITS_DOCUMENTS_LOAD_SUCCESS,
  BENEFITS_DOCUMENTS_LOAD_FAILED,
} from "../actions/documentsActions";

const initialState = {
  documents: {},
  type:"",
  fetching: false,
  fetched: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BENEFITS_DOCUMENTS_LOAD_BEGIN:
      return { ...state, fetching: true };
    case BENEFITS_DOCUMENTS_LOAD_FAILED:
      return { ...state, fetching: false, error: action.payload };
    case BENEFITS_DOCUMENTS_LOAD_SUCCESS:
      return { ...state, fetched: true, documents: action.payload };
    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/documentsReducer.jsx